import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"calendar\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 2v14h16V2H0zm15 13.059H1V3h14v12.059z\" fill=\"#CDCBCB\" fill-rule=\"nonzero\" /><path fill=\"#ECECEC\" fill-rule=\"nonzero\" d=\"M1 3h14v3H1z\" /><path fill=\"#CDCBCB\" fill-rule=\"nonzero\" d=\"M0 6h16v1H0zM3 0h2v4H3zM11 0h2v4h-2z\" /><path fill=\"#CDCBCB\" d=\"M4 12h8v1H4zM4 9h8v1H4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id